import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialFoodState } from "./food.types";
import { foodActions } from ".";
import { CLEAR_FOOD_STATE, FETCH_FOOD_FAILED, FETCH_FOOD_LIST_FAILED, FETCH_FOOD_LIST_PROGRESS, FETCH_FOOD_LIST_SUCCESS, FETCH_FOOD_PROGRESS, FETCH_FOOD_SUCCESS } from "./foodActions";


export const foodReducer = (
  state: IStoreState["food"] = initialFoodState,
  action: foodActions
) => {
  switch (action.type) {
    case FETCH_FOOD_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_FOOD_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_FOOD_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }
     case FETCH_FOOD_PROGRESS: {
          const newState = produce(state, (draftState) => {
            draftState.dataLoading = LoadState.InProgress;
            draftState.data = initialFoodState['data'];
          });
          return newState;
        }
        case FETCH_FOOD_SUCCESS: {
          const { data } = action.payload;
          const newState = produce(state, (draftState) => {
            draftState.dataLoading = LoadState.Loaded;
            draftState.data = data;
          });
          return newState;
        }
        case FETCH_FOOD_FAILED: {
          const { errorMessage } = action.payload;
          const newState = produce(state, (draftState) => {
            draftState.dataLoading = LoadState.Failed;
            draftState.error = errorMessage;
          });
          return newState;
        }
    case CLEAR_FOOD_STATE: {
      return initialFoodState;
    }
    default:
      return state;
  }
};
